import { compose, withProps } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import Grid from '../../components/GridView'
import { filter, isEmpty } from 'lodash';

const query = gql`
  query documents($where: JSON!) {
    documents(where: $where) {
      id
      cod
      type
      due_date
      metadata
      customer {
        id
        cod
        name
      }
      insurer {
        id
        cod
        name
      }
      children {
        id
      }
    }
  }
`
const withQuery = graphql(query, {
  options: () => ({
    variables: { where: { type: 'PROPOSAL', due_date: ['>=', '2020-01-01'] } }
  })
})

export default compose(
  withQuery,
  withProps(({ data }) => {
    // console.log(data)
    const dataset = filter(data.documents, doc => isEmpty(doc.children))

    return {
      columns: [
        {
          name: 'client',
          title: 'Cliente',
          getCellValue: row =>
            (row.customer && row.customer.name) ||
            (row.metadata && row.metadata.cpfs.join(';'))
        },
        {
          name: 'insurer',
          title: 'Seguradora',
          getCellValue: row =>
            (row.insurer && row.insurer.cod) ||
            (row.metadata && row.metadata.insurer)
        },
        { name: 'due_date', title: 'Vencimento', sort: 'asc', type: 'date' },
        {
          name: 'id',
          label: 'editar',
          to: '/documents',
          title: ' ',
          type: 'link'
        }
      ],
      extensions: [
        { columnName: 'id', width: 75, align: 'center' },
        { columnName: 'due_date', width: 150, align: 'center' },
        { columnName: 'insurer', width: 100, align: 'center' }
      ],

      dense: true,
      loading: data.loading,
      rows: dataset //filter(data.documents, doc => !doc.children) || []
    }
  })
)(Grid)
